var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRightcomponent = function SvgRightcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 1C7.705 1 1 7.705 1 16s6.705 15 15 15 15-6.705 15-15S24.295 1 16 1Z",
    stroke: "#A08264"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.761 17.081-4.608 4.677a.802.802 0 0 1-1.148 0l-.766-.777a.83.83 0 0 1 0-1.166l3.266-3.315-3.266-3.315a.83.83 0 0 1 0-1.165l.766-.778a.802.802 0 0 1 1.148 0l4.608 4.677a.826.826 0 0 1 0 1.162Z",
    fill: "#B39B83"
  })));
};
export default SvgRightcomponent;